module.exports = __webpack_public_path__ + "img/banners_info_with_undo.e730ac8a.webp";